import { render, staticRenderFns } from "./FixedValueDiscounts.vue?vue&type=template&id=f290cc78&"
import script from "./FixedValueDiscounts.vue?vue&type=script&lang=ts&"
export * from "./FixedValueDiscounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports